import React from 'react';
import styles from './MobileDashboardPage.module.scss';
import { Outline } from '@otcmarketsgroup/otcm-ui';
import { HeadTitle } from '../../components/HeadTitle';
import { MemoizedMobileDashboardEcnGrids } from '../MobileDashboardEcnGrids/MobileDashboardEcnGrids';
import { MemoizedMobileDashboardAtsGrids } from '../MobileDashboardAtsGrids/MobileDashboardAtsGrids';

class MobileDashboardPage extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      title: 'Dashboard',
      tableConfig: ['ecn', 'ats']
    };
  }

  renderGrid (i) {
    const tableConfig = this.state.tableConfig;
    if (tableConfig[i] === 'ecn') {
      return <div className={styles.ecnContainer}>
        <Outline
          mode='headingSmall'
          bottomBorderOnly={false}
          topBorderOnly={false}
          className={styles.contentHeader}
        >ECN</Outline><MemoizedMobileDashboardEcnGrids />
      </div>;
    } else if (tableConfig[i] === 'ats') {
      return <div className={styles.atsContainer}>
        <Outline
          mode='headingSmall'
          bottomBorderOnly={false}
          topBorderOnly={false}
          className={styles.contentHeader}
        >ATS</Outline><MemoizedMobileDashboardAtsGrids />
      </div>;
    }
  }

  renderTables () {
    const tableConfig = this.state.tableConfig;
    const _this = this;
    return tableConfig.map(function (item, index) {
      return <div key={'dashboard' + item}>{_this.renderGrid(index)}</div>;
    });
  }

  render () {
    return (
      <div id={'mobileDashboardPage'} >
        <HeadTitle title={this.state.title} />
        {this.renderTables()}
      </div>
    );
  }
}

export default MobileDashboardPage;
